export default __webpack_public_path__ + "static/media/welcome_bg.e46600cc.png";